import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from '@/app/components/ui/dropdown-menu';
import { DotsHorizontalIcon } from '@radix-ui/react-icons';
import { Flex } from '@radix-ui/themes';
import React from 'react';

interface Props {
  show: boolean;
  toggle: () => void;
}

const ToggleFlagged = ({ show, toggle }: Props) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Flex className="border p-0.5 rounded-xl cursor-pointer" onClick={toggle}>
          <DotsHorizontalIcon className="scale-90" />
        </Flex>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuCheckboxItem
          checked={show}
          onCheckedChange={toggle}
        >
          Show removed bids
        </DropdownMenuCheckboxItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ToggleFlagged
